import Service from "../components/services/service"
function Servicespage(){
    return(
        <>
        <Service/>
        </>
    )
}
export default Servicespage